module.exports = __webpack_public_path__ + "static/media/mf.487f7bd7.svg";